const bbs = {
    getLists: { api: '/api.php/Bbs/getLists', },
    getDetail: { api: '/api.php/Bbs/getDetail', },
    getJiabinDetail: { api: '/api.php/Bbs/getJiabinDetail', },
}
export default bbs
